import React, { forwardRef } from 'react';

export const Error = forwardRef((props, ref) => (
  <svg
    fill="none"
    height="40"
    ref={ref}
    viewBox="0 0 49 40"
    width="49"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.8961 12.4017V18.5507C25.8961 19.2029 25.8602 19.8479 25.7886 20.4857C25.7241 21.1236 25.6309 21.7865 25.5091 22.4745H23.5096C23.3877 21.7865 23.291 21.1236 23.2193 20.4857C23.1548 19.8479 23.1226 19.2029 23.1226 18.5507V12.4017H25.8961ZM22.7248 26.4412C22.7248 26.2047 22.7678 25.9826 22.8538 25.7747C22.947 25.5597 23.0724 25.377 23.2301 25.2265C23.3877 25.0688 23.5705 24.947 23.7783 24.861C23.9933 24.7678 24.2262 24.7212 24.4771 24.7212C24.7207 24.7212 24.9465 24.7678 25.1543 24.861C25.3693 24.947 25.5557 25.0688 25.7133 25.2265C25.871 25.377 25.9964 25.5597 26.0896 25.7747C26.1827 25.9826 26.2293 26.2047 26.2293 26.4412C26.2293 26.6849 26.1827 26.9107 26.0896 27.1185C25.9964 27.3263 25.871 27.5091 25.7133 27.6667C25.5557 27.8172 25.3693 27.9355 25.1543 28.0215C24.9465 28.1075 24.7207 28.1505 24.4771 28.1505C24.2262 28.1505 23.9933 28.1075 23.7783 28.0215C23.5705 27.9355 23.3877 27.8172 23.2301 27.6667C23.0724 27.5091 22.947 27.3263 22.8538 27.1185C22.7678 26.9107 22.7248 26.6849 22.7248 26.4412Z"
      fill="black"
    />
    <circle cx="24" cy="20" r="18.375" stroke="black" strokeWidth="3.25" />
  </svg>
));
